/* --------------------------------- IMPORTS -------------------------------- */

import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { PageTitle } from '../../../../../_metronic/layout/core';
import { AssessmentWizard } from './formController/AssessmentWizard';

/* -------------------------------------------------------------------------- */

/* -------------------------------- COMPONENT ------------------------------- */

const FacilityAssessmentPage: FC = () => {
    const { pfn_facilityid, pfn_facilityassessmentid } = useParams();

    return (
        <div>
            {pfn_facilityassessmentid && pfn_facilityid ? (
                <AssessmentWizard initialStep={0} assessmentId={pfn_facilityassessmentid} facilityId={pfn_facilityid} />
            ) : (
                <div>An error occured, please try again later</div>
            )}
        </div>
    );
};

/* -------------------------------------------------------------------------- */

/* --------------------------------- WRAPPER -------------------------------- */

const FacilityAssessmentWrapper: FC = () => {
    return (
        <>
            <PageTitle breadcrumbs={[]}>Annual Declaration</PageTitle>
            <FacilityAssessmentPage />
        </>
    );
};

/* -------------------------------------------------------------------------- */

/* --------------------------------- EXPORTS -------------------------------- */

export { FacilityAssessmentWrapper };

/* -------------------------------------------------------------------------- */
